/**
 * Pure recursive filter that drops nav items whose `requires` clause is not
 * satisfied and prunes empty groups. Shared by TopMenuBar (frontend) and the
 * /api/navigation backend route so both produce identical menus from the
 * single navigationConfig source.
 */

export interface NavItem {
  type: string;
  label: string;
  requires?: { feature: string; operation: string };
  children?: readonly NavItem[];
  [key: string]: unknown;
}

export type CanDo = (feature: string, operation: string) => boolean;

export function filterNavByPermission(items: readonly NavItem[], canDo: CanDo): NavItem[] {
  return items.flatMap((item): NavItem[] => {
    if (item.requires && !canDo(item.requires.feature, item.requires.operation)) {
      return [];
    }
    if (item.children) {
      const kept = filterNavByPermission(item.children, canDo);
      if (kept.length === 0) return [];
      return [{ ...item, children: kept }];
    }
    return [item];
  });
}
